<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData"  label-width="95px" size="mini">
            <el-form-item prop="" class="lable-width" label="部门">
                <el-select clearable class="input-width" :filter-method="bmfilter" @change="bmchange" v-model="editData.fName" filterable placeholder="请选择">
                    <el-option
                            v-for="(item,index) in bmdata"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
                <!--                <el-input class="input-width" placeholder="请输入dcs编号" clearable v-model="editData.no"></el-input>-->
            </el-form-item>
            <el-form-item prop="" class="lable-width" label="车间">
                <el-select clearable class="input-width" :filter-method="cjfilter" @change="cjchange"  v-model="editData.gName" filterable placeholder="请选择">
                    <el-option
                            v-for="(item,index) in cjdata"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
<!--                <el-input class="input-width" placeholder="请输入dcs编号" clearable v-model="editData.no"></el-input>-->
            </el-form-item>

            <el-form-item prop="" class="lable-width" label="轮班类型">
                <el-select @change="lbchange" clearable class="input-width"   v-model="editData.type" filterable placeholder="请选择">
                    <el-option
                            v-for="(item,index) in bztype"
                            :key="index"
                            :label="item.value"
                            :value="item.id">
                    </el-option>
                </el-select>
<!--                <el-input class="input-width" placeholder="请输入控件标题"  clearable v-model="editData.inputTitle"></el-input>-->
            </el-form-item>

            <el-form-item  prop="" class="lable-width" label="班组设置" >
                <div style="display:flex;align-items: center;" :class="[editData.sjddata.length==1||index==editData.sjddata.length-1?'':'mb18' ]" v-for="(item,index) in editData.sjddata" :key="index">
                    <el-time-picker
                            style="margin-right: 3px"
                            :disabled="item.bc=='休'"
                            :class="[editData.sjddata.length == 1?'ml30':(item.bc=='休'?'':'ml60'),'shuru']"
                            arrow-control
                            format="HH:mm"
                            value-format="HH:mm"
                            v-model="item.start"
                            placeholder="开始">
                    </el-time-picker>
                    至
                    <el-time-picker
                            style="margin-left: 3px"

                            :disabled="item.bc=='休'"


                            class="shuru"
                            arrow-control
                            format="HH:mm"
                           value-format="HH:mm"

                           v-model="item.end"
                            placeholder="结束">
                    </el-time-picker>
<!--                <el-input  :class="[editData.sjddata.length == 1?'ml30':'ml60','shuru']" placeholder="开始时间" clearable v-model="item.start"></el-input>-->
<!--                - -->
<!--                <el-input  class="shuru" placeholder="结束时间" clearable v-model="item.end"></el-input>-->
<!--                   <div @click="bzclick(item)" style="width: 100%;">-->

                    <el-select @change="dh(item,index)" @click.native="bzclick(item,index)" @remove-tag="bzclick(item,index)" @clear="bzclick(item,index)" value-key="id" clearable class="sinput-width"  multiple v-model="item.bz" filterable placeholder="班组">
                                        <el-option

                                                v-for="item in bzdata"
                                                :key="item.bid"
                                                :label="item.bzName"
                                                :value="item.bid">
                                        </el-option>
                    </el-select>
<!--                   </div>-->

                    <el-select  :disabled="item.bc=='休'"  style="width: 100px;" clearable class=""   v-model="item.bc" filterable placeholder="班次">
                                            <el-option
                                                    v-for="(item,index) in bcdata"
                                                    :key="index"
                                                    :label="item"
                                                    :value="item">
                                            </el-option>
                    </el-select>
                    <i v-if="item.bc!=='休'" class="el-icon-plus" style="font-size: 20px;color: #3e82e8;margin-left: 10px" @click="add(index)"></i>
                    <i v-show="editData.sjddata.length > 1&&item.bc!=='休'" class="el-icon-minus" style="font-size: 20px;color: #3e82e8;margin-left: 10px" @click="del(index)"></i>
                </div>

            </el-form-item>
            <el-form-item prop="" class="lable-width" label="时长(h)">

                                <el-input oninput="value=value.replace(/\D*(\d*)(\.?)(\d{0,3})\d*/,'$1$2$3')
.replace(/^0+(\d)/, '$1')
.replace(/^\./, '0.')
.match(/^\d*(\.?\d{0,1})/g)[0] || ''" class="input-width" placeholder="请输入时长"  clearable v-model="editData.duration"></el-input>
            </el-form-item>


            <el-form-item prop="" class="lable-width" label="弹性时间(min)">

                <el-input oninput="value=value.replace(/[^\d]/g,'')" class="input-width" placeholder="请输弹性时间"  clearable v-model="editData.elasticTime"></el-input>
            </el-form-item>


            <el-form-item  label="是否启用">
                <div style="margin-left: 50px">
                    <el-radio v-model="editData.state" :label="1">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <!---->
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'AddShift',
        props:{

            editData:{
                type:Object
            }
        },
        data(){
            return{
                pd:0,
                bztype:[
                    {
                        id:1,
                        value:'固定班'
                    },
                    {
                      id:4,
                      value:'两班两倒'
                    },
                    {
                        id:2,
                        value:'三班两倒'
                    },{
                        id:3,
                        value:'四班三倒'
                    }
                ],

                cf:'',
                cffb:false,
                jgsc:'',
                gwcgdata:999,
                bmdata:[],
                cjdata:[],
                bzdata:[],
                bzid:[],
                gwdata:[


                ],
                value:'',
                weekdate:'',
                // gwdata:[],
                // stationdata:[],
                monthdate:'',
                positionopen:0,
                nfcopen:0,
                monthData:[],
                consumername:[],
                datatimes:[],
                templateData:[],
                cjpanduan:0,
                bzpanduan:0,
                bcdata:[],
                cbopen:0,
                rules:{},
                olddata:[]
            }
        },
        watch:{
        },
        mounted(){
            this.getDepartmentsList()
            this.bcList()
            // console.log(this.editData)
            if(this.editData.id!==0&&!!this.editData.positionTime){
                let add=[]

                this.editData.positionTime=this.editData.positionTime.split(',')
                this.editData.bcNotes=this.editData.bcNotes.split(',')
                // console.log(this.editData.bzNames.split(','))
                // this.editData.bzNames=this.editData.bzNames.split(',')

                this.editData.bzNames=this.editData.bzNames.split(';')
                // console.log(this.editData)
                this.editData.positionTime.map(item=>{
                    add.push({
                        start:item.substring(0,5),
                        end:item.substring(6,11),

                    })

                })
                let acc={
                    start:'',
                    end:'',
                    bc:'休',
                    bz:[]
                }
                this.editData.bcNotes.filter((item,i)=>{
                    if(item=='休'){
                        add.splice(i,0,acc)
                    }
                })
                add.forEach((it,index)=>{
                    this.$set(it,'bc',this.editData.bcNotes[index])
                    this.$set(it,'bz',[this.editData.bzNames[index]])
                    // it.bz=it.bz.split(',')
                })
                add.filter(item=>{
                   item.bz.map(it=>{
                       if(!!it){
                           item.bz=it.split(',')

                       }else{
                           item.bz=''
                       }
                       // console.log(it.split(','))
                   })
                //     item.bz=item.bz.split(',')
                })
                // console.log(add)

                // this.editData.bcNotes


                // this.$set(this.editData,'sjddata',add)
                // if(this.editData.type!==1){
                //     this.$set(this.editData,'cbopen',1)
                //     let abc={
                //         start:'',
                //         end:'',
                //         bc:'休',
                //         bz:[]
                //     }
                //     this.$set(this.editData,'sjddata',add)
                //
                //     this.editData.sjddata.splice(this.editData.sjddata.length-1,0,abc)
                //
                //
                // }else{
                    this.$set(this.editData,'sjddata',add)
                //
                // console.log(this.editData)
                // }
            }

            // console.log(this.editData)
            // if(this.editData.id!==0){
            //   this.dcsdetail()
            // }
        },
        methods:{


            dh(val,index){

            },
            bzclick(val,i){
                if(this.pd==999){
                   // this.editData.bids.split(';').filter(item=>{
                   //     this.bzid.push(parseFloat(item))
                   //  })
                   //  // console.log(this.bzid)
                    this.pd=1
                    this.bzList()

                }else{
                    this.cbopen=1
                    let acc=[]
                    this.bzid=[]
                    val.bz.map(it=>{
                        if(typeof it==='number'){

                        }else{
                            acc.push(it)
                        }
                    })
                    let adc=[]
                    // console.log(this.olddata)
                    acc.forEach(item => {
                        adc=this.olddata.filter(_item => _item.bzName === item)
                        // this.bzid.push( this.bzdata.filter(_item => _item.bzName === item)[0] );
                    })
                    adc.map(item=>{
                        this.bzid.push(item.bid)
                    })
                    // if(i==this.editData.sjddata.length-1){
                    let qbid=[]
                    this.editData.sjddata.map((item,i)=>{
                        item.allbzid=item.bz.join(',')
                        // console.log(item.allbzid)
                        // item.allbz.map(it=>{
                        if(typeof item.allbzid==='number'){

                        }else{
                            // console.log(item)
                            this.olddata.map(tt=>{
                                // console.log(tt.bzName)
                                // console.log(item.allbzid)
                                if(tt.bzName==item.allbzid){
                                    // console.log(tt.bid)
                                    item.allbzid=tt.bid
                                }
                            })
                        }
                        qbid.push(item.allbzid)
                    })
                    // console.log(qbid)
                    // console.log(this.bzid)
                    let abc=[]
                   this.bzid=qbid
                    this.bzid.map(item=>{
                        if(typeof item==='number'){

                        }else{

                            // console.log(item.split(','))
                            item.split(',').map(item=>{
                                if(!parseFloat(item)){
                                    // console.log(item)
                                    this.olddata.map(tt=>{
                                        // console.log(tt.bzName==item)
                                        // console.log(item.allbzid)
                                        if(tt.bzName==item){
                                            abc.push(tt.bid)
                                            // console.log(123)
                                            // console.log(tt.bid)
                                            // item=tt.bid
                                            // console.log(item)
                                        }
                                    })
                                }else{
                                    abc.push(item)
                                }
                            })
                            // if(parseFloat(item.spli))
                            // this.olddata.map(tt=>{
                            //     // console.log(tt.bzName)
                            //     // console.log(item.allbzid)
                            //     if(tt.bzName==item.allbzid){
                            //         // console.log(tt.bid)
                            //         item.allbzid=tt.bid
                            //     }
                            // })
                        }
                    })
                    let jjj=[]
                    abc.filter(item=>{
                        jjj.push(parseFloat(item))
                    })
                    this.bzid=[...this.bzid,...jjj]
                    this.bzid.filter((item,i)=>{
                        if(typeof item==='number'){
                        }else{
                            this.bzid.splice(i,1)

                        }
                    })
                    // console.log(this.bzid)
                    // this.pd=1
                    val.bz.map(item=>{
                        if(typeof item==='number'){
                            this.bzid.push(item)
                        }
                    })

                    this.bzList()
                }

            },
            bmfilter(val){
                // this.editData.bmName=val
                this.getDepartmentsList(val)
                // console.log(this.editData.bmName)
            },
            // gwfilter(val){
            //     this.getStationsList(val)
            // },
            gwsearch(val){
                // this.editData.sid=val
                // this.getStationsList(val)
            },
            gwchange(val){
                this.editData.station=val
                // console.log(val)
            },
            cjfilter(val){
                // console.log(val)
                // if(this.editData.bmName!==''){
                //     this.getWorkshopsList(val)
                //
                // }

            },
            //部门
            async getDepartmentsList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                if(!val){
                    val=''
                }
                let params = {
                    search:val
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getDepartmentsList(params);
                if (res.code == 1) {
                    this.bmdata=res.departmentsList
                    // console.log(this.editData.gid==undefined)
                    // this.bzdata=[]
                    if(!!this.editData.gid){
                        this.bzList1()

                        // this.bzList()
                        this.getWorkshopsList()
                    }

                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //车间
            async bcList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {

                }
                // console.log(params)
                // return
                let res = await API.bcList(params);
                if (res.code == 1) {
                    this.bcdata=res.data
                    // if(this.editData.cid!==undefined){
                    //     this.getTeamsList()
                    //
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async bzList(val) {

                // console.log(this.editData.bids.split(';').)

                // return
                this.bzid.map((item,index)=>{
                    if(item==''){
                        this.bzid.splice(index,1)
                    }
                })
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    gid:this.editData.gid,
                    exclude:this.bzid
                }
                // console.log(params)
                // return
                let res = await API.bzList(params);
                if (res.code == 1) {

                    // if(this.pd==1){
                        this.bzdata=res.data

                    // }
                    // if(this.editData.cid!==undefined){
                    //     this.getTeamsList()
                    //
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async bzList1(val) {

                // console.log(this.editData.bids.split(';').)

                // return
                this.bzid.map((item,index)=>{
                    if(item==''){
                        this.bzid.splice(index,1)
                    }
                })
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    gid:this.editData.gid,
                    exclude:[]
                }
                // console.log(params)
                // return
                let res = await API.bzList(params);
                if (res.code == 1) {
                    // this.bzdata=res.data
                    // if(this.cbopen==0){
                    if(this.cbopen==0&&this.pd==0){
                        // console.log(1)
                        this.olddata=JSON.parse(JSON.stringify(res.data))
                    }
                        // this.olddata=JSON.parse(JSON.stringify( res.data))
                    // console.log(1)
                    // }
                    // if(this.editData.cid!==undefined){
                    //     this.getTeamsList()
                    //
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //车间
            async getWorkshopsList(val) {
                if(!val){
                    val=''
                }
                // console.log(this.editData.bmName)

                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val,
                    pid:this.editData.fid
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getWorkshopsList(params);
                if (res.code == 1) {
                    this.cjdata=res.workshopsList
                    // if(this.editData.cid!==undefined){
                    //     this.getTeamsList()
                    //
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            cfipt(e){
                // if(e==1){
                //     this.cffb=!this.cffb
                //     // this.editData.beginTime
                // }else{
                //     this.cffb=!this.cffb
                //
                // }
                // console.log(e)
            },
            bzfilter(val){

            },
            bmchange(val){
                this.editData.fid=val
                this.editData.sjddata.filter(item=>{
                    item.bz=[]
                })
                this.editData.gName=''

                if(this.editData.bmName!==''){
                    this.getWorkshopsList()
                }
                // this.editData.bzName=''
            },
            cjchange(val){
                // console.log(val)
                this.editData.gid=val
                this.editData.sjddata.filter(item=>{
                    item.bz=[]
                })
                this.bzList()

                // this.editData.cid=val

                // if(this.editData.cjName!==''){
                //     this.getTeamsList()
                //
                // }
            },
            bzchange(val){
                this.editData.bid=val
                // if(this.editData.cjName!=='') {
                //
                //     this.getTeamsList()
                // }
            },
            nfcfocus(){
                this.nfcopen=1
            },
            positionfocus(){
                this.positionopen=1

            },
            nfcblur(){
                this.nfcopen=0
            },
            positionblur(){
                this.positionopen=0
            },
            timepick(val){
                if(val==null){
                    this.editData.beginTime=''
                }
            },
            cycleselect(val){
                this.editData.cycle=val

                // if(val==''){
                this.editData.beginTime=''
                // }
                this.monthdate=''
                this.weekdate=''
                // console.log(this.datatimes)
            },
            radiojudge(val){

            },
            lbchange(val){
                // console.log(val)
                if(val!==1&&val!==4){
                    // console.log(1)
                    if(!!val){
                        this.editData.sjddata.filter((item,i)=>{
                            if(item.bc=='休'){
                                this.editData.cbopen=1

                            }
                        })
                        if(this.editData.cbopen!==1){
                            let add={
                                start:'',
                                end:'',
                                bc:'休',
                                bz:[]
                            }
                            this.editData.sjddata.splice(this.editData.sjddata.length,0,add)
                        }


                    }else{
                        this.editData.cbopen=0
                        this.editData.sjddata.filter((item,i)=>{
                            if(item.bc=='休'){
                                this.editData.sjddata.splice(i,1)

                            }
                        })
                    }

                    // if(this.editData.state==1){
                    //     this.editData.cbopen=1

                        // this.editData.sjddata.push({
                        //
                        // })
                    // }
                }else{
                    // console.log(1)
                    this.editData.cbopen=0

                    this.editData.sjddata.filter((item,i)=>{
                        if(item.bc=='休'){
                            this.editData.sjddata.splice(i,1)

                        }
                    })
                }

            },
            localradio(val){
                // console.log(val)
                this.editData.nfc=val
                // this.tishi=1
            },
            ...mapActions(["getCurrentMenuId"]),

            //部门


            //岗位


            //模板

            //业务配置保存
            async save() {
                // if(!this.editData.fName){
                //     this.bmdata.filter(item=>{
                //         if(item==this.editData.fName){
                //             console.log(item)
                //         }
                //     })
                // }
                // console.log(this.editData)
                if(!this.editData.fid){
                    this.editData.fid=this.editData.fName
                }else{
                    // this.editData.fName=0
                }
                if(!this.editData.gid){
                    this.editData.gid=this.editData.gName
                }else{
                    // this.editData.gid=0
                }
                if(!this.editData.duration){
                    this.editData.duration=0
                }
                if(!this.editData.fid){
                    this.$message({
                        message: '请选择部门',
                        type: 'warning'
                    });
                    return
                }
                if(!this.editData.gid){
                    this.$message({
                        message: '请选择车间',
                        type: 'warning'
                    });
                    return
                }
                if(!this.editData.type){
                    this.$message({
                        message: '请选择轮班类型',
                        type: 'warning'
                    });
                    return
                }
                for(let i=0;i<this.editData.sjddata.length;i++){
                    let a=this.editData.sjddata[i]
                    if(a.bz.length==0){
                        this.$message({
                            message: '请选择轮班班组',
                            type: 'warning'
                        });
                        return
                    }else if(!a.start&&a.bc!=='休'){
                        this.$message({
                            message: '请选择开始时间',
                            type: 'warning'
                        });
                        return

                    }else if(!a.end&&a.bc!=='休'){
                        this.$message({
                            message: '请选择结束时间',
                            type: 'warning'
                        });
                        return
                    }else if(!a.bc){
                        this.$message({
                            message: '请选择班次',
                            type: 'warning'
                        });
                        return
                    }else if(a.start==a.end&&a.bc!=='休'){
                        this.$message({
                            message: '开始时间等于结束时间',
                            type: 'warning'
                        });
                        return
                    }
                }
                if(!this.editData.duration){
                    this.$message({
                        message: '请输入时长',
                        type: 'warning'
                    });
                    return
                }
                // if(this.editData.elasticTime ==''){
                //     this.$message({
                //         message:'请输入弹性时间',
                //         type: 'warning'
                //     });
                // }
                    let a=[]
                let b=[]
                let c=[]
                let g=[]
                this.editData.sjddata.map((item,i)=>{
                    // if(item.bz.length==0&&this.editData.sjddata.length>1){
                    //     this.editData.sjddata.splice(i,1)
                    // }
                    // console.log(item.bz)
                    if(!!item.start&&!!item.end){
                        a.push(item.start+'-'+item.end)
                    }else {
                        // a.push(item.start)
                    }
                    // acc.forEach(item => {
                    //     adc=this.olddata.filter(_item => _item.bzName === item)
                    //     // this.bzid.push( this.bzdata.filter(_item => _item.bzName === item)[0] );
                    // })
                    // item.bz.map(it=>{
                    //     console.log(it)
                    //     if(typeof it==='number'){
                    //
                    //     }else{
                    //         // console.log(1)
                    //         this.olddata.map(tt=>{
                    //             // console.log(tt.bzName==it)
                    //             if(tt.bzName==it){
                    //                 // console.log(tt.bid)
                    //                 it=tt.bid
                    //             }
                    //         })
                    //     }
                    // })
                    // if(item.bz)
                    // console.log(typeof item.bz)
                    // console.log(item.bz)
                    item.allbz=item.bz
                    // console.log(item.allbz)
                    // return
                    // item.allbz.map(it=>{
                    // console.log(typeof item.allbz)
                    item.bz.map(ii=> {
                        // console.log(ii)
                        if (typeof ii === 'number') {
                            // g.push(ii)
                        } else {
                            // console.log(1)
                            this.olddata.map(tt => {
                                // console.log(item.allbz)
                                // console.log(item.allbz == tt.bzName)
                                // console.log(tt.bzName)
                                // console.log(item.allbz)

                                // console.log(tt.bzName==it)
                                // console.log(ii)
                                if (tt.bzName == ii) {
                                    ii = tt.bid
                                    // console.log(ii)
                                    // console.log(tt)
                                    // g.push(tt.bid)
                                }
                            })
                        }
                        // console.log(ii)
                    })

                        // throw new Error()
                    // })

                    // console.log(item)

                })


                this.editData.sjddata.forEach((item,index)=>{
                    // g=[]


                        item.allbz.map((it,i)=>{
                            if (typeof it === 'number') {
                                // g.push(ii)
                            } else {
                                // console.log(1)
                                this.olddata.map(tt => {
                                    // console.log(item.allbz)
                                    // console.log(item.allbz == tt.bzName)
                                    // console.log(tt.bzName)
                                    // console.log(item.allbz)

                                    // console.log(tt.bzName==it)
                                    // console.log(it)
                                    if (tt.bzName == it) {
                                        this.editData.sjddata[index].allbz[i] = tt.bid
                                        // this.$set()
                                        // g.push(it)
                                        // item.allbz=g
                                        // g.push(tt.bid)
                                    }
                                })
                            }

                        })
                    // console.log(item)
                })
                // console.log( this.editData.sjddata)
                this.editData.sjddata.map((item,i)=> {
                    if(i<this.editData.sjddata.length-1&&this.editData.sjddata[i+1].allbz!==''){
                        // if(item.)
                        b.push(item.allbz+';')
                    }else{
                        b.push(item.allbz)
                    }
                    c.push(item.bc)
                })
                        // console.log(this.editData.sjddata)

                // g=g.join(',')
                // this.editData.sjddata.map((item,i)=> {
                //
                // })

                        // })
                // console.log(g)
                // g=g.join(',')

                // this.editData.sj
                this.editData.positionTime=a.join(',')
                // console.log(this.editData.bids)
                this.editData.bcNotes=c.join(',')
                this.editData.bids=b.join('')
                // if(!this.editData.bids){
                //     this.$message({
                //         message: '请选择轮班班组',
                //         type: 'warning'
                //     });
                // }
                // console.log(this.editData)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    fid:this.editData.fid,
                    gid:this.editData.gid,
                    type:this.editData.type,
                    positionTime:this.editData.positionTime,
                    bids:this.editData.bids,
                    state:this.editData.state,
                    duration:this.editData.duration,
                    bcNotes:this.editData.bcNotes,
                    elasticTime: this.editData.elasticTime

                }
                // for(let i in params){
                //     if(params[i]===''){
                //         delete params[i]
                //     }
                // }

                // console.log(params)
                // return
                let res = await API.save(params);
                if (res.code == 1) {
                    this.$emit('shiftlist')
                    this.$emit('close')
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });

                } else if (res.code == -2) {

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else if (res.code == -1){
                    this.editData.beginTime=''
                    this.$message({
                        message:res.message,
                        type:'warning'
                    })
                }else {
                    this.editData.beginTime=''
                    this.$message.error(res.message);

                }
            },
            close(){
                this.$emit('close')
            },
            lll(){
                // console.log(1)
            },
            add(i){
                let add={
                    start:'',
                    end:'',
                    bc:'',
                    bz:[]
                }
              this.editData.sjddata.splice(i+1,0,add)
            },
            del(i){
                this.editData.sjddata.splice(i,1)

            },
            onSubmit(editData){
//获取对应ID
        //      this.editData.push(),
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        // console.log(this.editData)
                        // console.log(this.editData.xfname)

                        // let add1=this.consumername.filter(item=>{
                        //     return  item.name==this.editData.consumerName
                        // })
                        // console.log(add1)
                        // this.editData.consumerId=add1[0].id
                        this.save()

                    } else {
                        // console.log('error submit!!');
                        return false;
                    }
                });


            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 470px;
    }
    .sinput-width{
        width: 150px;
        /*margin-left: 28px;*/
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
    /deep/.sjd .el-input--mini{
        /*width: 200px;*/
    }
    .shuru{
        width: 100px !important;
    }
    .mb18{
        margin-bottom: 18px;
    }
    .ml60{
        margin-left: 60px;
    }
    .ml30{
        margin-left: 30px;
    }
    /deep/.el-form-item__label{
        padding: 0;
    }
</style>